// extracted by mini-css-extract-plugin
export default {"instructions":"styles_instructions__pQ5dP","button":"styles_button__de2Ga","image":"styles_image__x5mX7"};